const socialChannels = [
  { icon: 'ri-facebook-circle-fill', href: 'https://www.facebook.com/profile.php?id=61572333684687', label: 'Facebook', color: 'hover:text-fuchsia-400' },
  { icon: 'ri-instagram-line', href: 'https://www.instagram.com/zpiritualzwebshop/', label: 'Instagram', color: 'hover:text-pink-400' },
  { icon: 'ri-tiktok-line', href: 'https://www.tiktok.com/@zpiritualz.com', label: 'TikTok', color: 'hover:text-violet-400' },
  { icon: 'ri-pinterest-line', href: 'https://www.pinterest.com/spiritualshopnl', label: 'Pinterest', color: 'hover:text-rose-400' },
  { icon: 'ri-whatsapp-line', href: 'https://wa.me/31698765432', label: 'WhatsApp', color: 'hover:text-emerald-400' },
];

export const SocialSidebar = () => {
  return (
    <aside className="fixed right-4 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-2">
      {socialChannels.map(ch => (
        <a
          key={ch.label}
          href={ch.href}
          aria-label={ch.label}
          target="_blank"
          rel="nofollow noreferrer"
          className={`w-9 h-9 flex items-center justify-center rounded-full bg-[#150025]/80 border border-violet-500/20 text-white/50 ${ch.color} backdrop-blur-sm transition-all duration-300 hover:border-current hover:scale-110 cursor-pointer`}
        >
          <i className={`${ch.icon} text-sm`} />
        </a>
      ))}
    </aside>
  );
};
